/* eslint-disable import/no-unresolved */
import 'javascripts/portal_used_model_v2/our_stores';
import 'stylesheets/portal_used_model_v2/our_stores';
